import { Instance, types } from 'mobx-state-tree';
import { SELECTED_MENU_ITEMS } from '../_models/dynamic-modal-layer/dynamicModalLayer.constants';

export type PhotoDrawerInstance = Instance<typeof PhotoDrawer>;

export const PhotoDrawer = types
  .model({
    selectedImageIds: types.array(types.string),
    imagesUploaded: types.boolean,
    picker: types.optional(types.enumeration(Object.values(SELECTED_MENU_ITEMS)), SELECTED_MENU_ITEMS.Computer),
  })
  .actions(self => {
    return {
      addImageId: (id: string) => {
        self.selectedImageIds.push(id);
      },
      removeImageId: (id: string) => {
        self.selectedImageIds = self.selectedImageIds.filter(elem => elem !== id);
      },
      clearSelectedImageIds: () => {
        self.selectedImageIds = [];
      },
      setImagesUploaded: (value: boolean) => {
        self.imagesUploaded = value;
      },
      setPicker: (source: SELECTED_MENU_ITEMS) => {
        self.picker = source;
      },
    };
  });
